import type { ReactNode } from 'react';

import { Card, Typography } from '@arco-design/web-react';

import styles from '@/delivery-type-plugin/styles/maas-model-step.module.less';

interface ModelStepSectionProps {
  /** 区块标题 */
  title: string;
  /** 区块说明 */
  description?: string;
  children: ReactNode;
}

/** 模型配置步骤内的分区卡片 */
export function ModelStepSection({ title, description, children }: ModelStepSectionProps) {
  return (
    <Card bordered className={styles.sectionCard}>
      <div className={styles.sectionHeader}>
        <Typography.Text bold className={styles.sectionTitle}>
          {title}
        </Typography.Text>
        {description ? (
          <Typography.Text type="secondary" className={styles.sectionDesc}>
            {description}
          </Typography.Text>
        ) : null}
      </div>
      <div className={styles.sectionBody}>{children}</div>
    </Card>
  );
}

export default ModelStepSection;
